import { SvgClockIn, SvgLogoWhite } from "@/components/SvgIcon";
import MenuAction from "@/components/common/MenuAction/MenuAction";
import { IMenuTypes } from "@/utils/models/core";
// import {
// 	Popover,
// 	PopoverContent,
// 	PopoverTrigger,
// } from "@/components/ui/popover";
import { clsx } from "clsx";
import { Button } from "@/components/ui/button";
import Modal from "@/components/common/Modal/Modal";
import { useEffect, useState } from "react";
import Camera, { ICamera } from "@/components/feature/Camera/Camera";
import { API_URL } from "@/utils/api/config";
import UpdateStatus from "@/components/feature/UpdateStatus/UpdateStatus";
// import BadgeStatus from "@/components/feature/Badge/Badge";
import Activity from "@/components/feature/Activity";
import { useTsRestQueryClient } from "@ts-rest/react-query";
import { opusClient } from "@/utils/rest-client/opus-client";
import useAuth from "@/hooks/useAuth";
// import { XMarkIcon } from "@heroicons/react/24/outline";
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { format, parseISO } from "date-fns";
// import { TStatus } from "@/utils/types/app";
import { useNavigate } from "react-router-dom";

interface IHeader {
	menu: IMenuTypes[];
	setStatusOpen: (x: boolean) => void;
	statusOpen: boolean;
}

const Header = ({ menu, setStatusOpen, statusOpen }: IHeader) => {
	const { user, getMe } = useAuth();
	const navigate = useNavigate();
	const apiQueryClient = useTsRestQueryClient(opusClient);

	// const [openPop, setOpenPop] = useState<boolean>(false);
	const [attendanceOpen, setAttendanceOpen] = useState<boolean>(false);

	const { data: latestTimeLog, refetch: refetchLatestTimeLog } =
		apiQueryClient.users.getLatestUserAttendances.useQuery(
			["latest-attendance"],
			{ params: { userId: user!.id } },
			{
				queryKey: ["latest-attendance"],
				retry: (failureCount, error) => {
					// if (error instanceof Error) {
					// 	console.log(error?.stack);
					// }
					return failureCount < 3 && error.status !== 404;
				},
			}
		);
	const isToday =
		latestTimeLog &&
		format(parseISO(latestTimeLog!.body!.day), "yyyy-MM-dd ") ===
			format(new Date(), "yyyy-MM-dd ");

	// Cases to consider
	// no attendance logs yet: CLOCK IN
	// has attendance, but not today: CLOCK IN
	// has attendance, but today: CLOCK OUT

	const purpose: ICamera["purpose"] =
		!latestTimeLog || (latestTimeLog && !isToday) ? "Clock In" : "Clock Out";

	// const log = [
	// 	purpose == "Clock In"
	// 		? {
	// 				name: "Clock in",
	// 				description:
	// 					"Make sure to log your hours to ensure you're marked as present.",
	// 				href: "##",
	// 				icons: <SvgClockIn className="w-5 h-5" />,
	// 				buttons: (
	// 					<Button
	// 						variant="default"
	// 						className="w-28 rounded-2xl bg-opus-blue-100 !py-1 !px-2 h-8"
	// 						disabled={latestTimeLog?.body.in && isToday}
	// 						onClick={() => setAttendanceOpen(true)}>
	// 						Clock In
	// 					</Button>
	// 				),
	// 		  }
	// 		: {
	// 				name: "Clock out",
	// 				description:
	// 					"Our clients depend on our availability during business hours. By staying until at least 3 PM, we can address their needs effectively.",
	// 				href: "##",
	// 				icons: <SvgClockIn className="w-5 h-5" />,
	// 				buttons: (
	// 					<Button
	// 						variant="default"
	// 						className="w-28 rounded-2xl bg-opus-blue-100 !py-1 !px-2 h-8"
	// 						disabled={!latestTimeLog?.body.in && !isToday}
	// 						onClick={() => setAttendanceOpen(true)}>
	// 						Clock Out
	// 					</Button>
	// 				),
	// 		  },
	// 	{
	// 		name: "Update Attendance/Status",
	// 		description:
	// 			"Update your attendance or status so we can track your availability.",
	// 		href: "##",
	// 		icons: <SvgInfo className="w-5 h-5" />,
	// 		buttons: (
	// 			<Button
	// 				variant="default"
	// 				className="w-28 rounded-full bg-white text-opus-gray-800 hover:text-white  !py-1 !px-2 h-8"
	// 				onClick={() => setStatusOpen(true)}>
	// 				Update
	// 			</Button>
	// 		),
	// 	},
	// ];

	useEffect(() => {
		getMe();
	}, [getMe]);

	return (
		<div className="relative w-full bg-opus-blue-100">
			<div className="relative flex flex-wrap justify-between mx-auto px-2 container py-5">
				<div className="flex items-center space-x-10">
					<div
						className="text-white text-md cursor-pointer"
						onClick={() => navigate("/dashboard", { replace: true })}>
						<SvgLogoWhite className="w-44" />
					</div>
				</div>
				<div className="flex items-center space-x-3">
					<Button
						variant={"default"}
						className="bg-opus-blue-400 py-3 px-5  space-x-2 rounded-lg"
						onClick={() => setAttendanceOpen(true)}>
						<SvgClockIn className="w-5 h-5 fill-current text-white mr-2" />
						{purpose}
					</Button>
					{/* <div>
						<Popover open={openPop} onOpenChange={setOpenPop}>
							<PopoverTrigger asChild>
								<Button
									variant="default"
									className="bg-inherit hover:bg-inherit p-0">
									<BadgeStatus status={user!.userStatus!.status as TStatus} />
								</Button>
							</PopoverTrigger>
							<PopoverContent className="w-[600px] relative right-56">
								<div className="overflow-hidden w-full">
									<div className="flex justify-between">
										<div className="text-opus-gray-400 text-lg font-gilroy-semibold">
											Log Time
										</div>
										<div
											className="text-opus-gray-400 font-gilroy-semibold cursor-pointer"
											onClick={() => setOpenPop(false)}>
											<XMarkIcon className="w-5 h-5" />
										</div>
									</div>
									<div className="relative gap-8 bg-white space-y-4">
										{log.map((item, index) => (
											<div
												key={index}
												className="bg-opus-gray-600 rounded-lg p-2 my-2  flex items-center justify-between">
												<div key={index} className="flex space-x-2">
													<div className=" rounded-full bg-white w-12 h-10 flex items-center justify-center">
														{item.icons}
													</div>
													<div className="w-full">
														<div className="font-bold text-sm">{item.name}</div>
														<div className="text-xs mr-2 w-[350px]">
															{item.description}
														</div>
													</div>
												</div>
												<div onClick={close}>{item.buttons}</div>
											</div>
										))}
									</div>
								</div>
							</PopoverContent>
						</Popover>
					</div> */}
					{/* <div>
						<SvgNotification className="w-8 h-8" />
					</div> */}
					<div className="relative">
						{user!.profilePicture ? (
							<div
								className={clsx(
									"bg-no-repeat bg-cover bg-center",
									"rounded-full h-10 w-10 ml-3"
								)}
								style={{
									backgroundImage: `url(${API_URL}/files/${
										user!.profilePicture.id
									})`,
								}}
							/>
						) : (
							<div className="flex items-center justify-center bg-gray-200 rounded-full h-10 w-10 ml-3">
								{user!.firstName && user!.lastName ? (
									<span className="text-gray-600 font-bold">
										{user!.firstName.charAt(0).toUpperCase()}
										{user!.lastName.charAt(0).toUpperCase()}
									</span>
								) : (
									<span className="text-gray-600 font-bold">?</span>
								)}
							</div>
						)}

						<div className="absolute top-6 right-0">
							<Activity activity={user!.userStatus!.activity} />
						</div>
					</div>
					<div>
						<MenuAction
							menuButton={
								<div className="text-white">Hi {user?.firstName}</div>
							}
							menu={menu}
						/>
					</div>
				</div>
			</div>
			<Dialog open={attendanceOpen} onOpenChange={setAttendanceOpen}>
				<DialogContent>
					<DialogHeader className="">
						<DialogTitle className="pt-4 w-full flex justify-between items-center">
							<span className="font-semibold text-xl  text-opus-gray-400">
								OPUS REMOTE
							</span>
							<span className="text-lg  text-opus-gray-400">{purpose}</span>
						</DialogTitle>
						<DialogClose onClick={close} />
					</DialogHeader>

					<Camera
						setOpen={setAttendanceOpen}
						isLatestTimeLogToday={isToday}
						latestTimeLog={latestTimeLog?.body}
						purpose={purpose}
						refetchLatestTimeLog={refetchLatestTimeLog}
					/>
				</DialogContent>
			</Dialog>
			<Modal title=" " isOpen={statusOpen} setOpen={setStatusOpen}>
				<UpdateStatus setStatusOpen={setStatusOpen} />
			</Modal>
		</div>
	);
};

export default Header;
